import { createContext, useContext } from 'react';
import type { ShopInsuranceContextType } from '@/features/shop-insurance';

const ShopInsuranceContext = createContext<ShopInsuranceContextType | undefined>(undefined);

export function useShopInsuranceContext() {
  const context = useContext(ShopInsuranceContext);

  if (!context) {
    throw new Error('useShopInsuranceContext must be used within a ShopInsuranceProvider');
  }

  return context;
}

export { ShopInsuranceContext };
